module.exports = __webpack_public_path__ + "media/react/marketing/pages/gre/home/sections/wall_of_love/assets/heart_icon-b59deffa3c6147f7985bc940f22bcdc6.svg";